import { StyleSheet, theme } from "@clearabee/ui-library";

export const styles = StyleSheet({
  verticalPanel: {
    display: "flex",
    flexDirection: "column",
    minWidth: 300,
    marginRight: theme.spacing.small,
    padding: `${theme.spacing.xsmall2} 0`,
    backgroundColor: theme.colors.brand.darkest,
    flex: 1,
  },
  horizontalPanel: {
    display: "flex",
    flexDirection: "row",
    marginBottom: theme.spacing.small,
    padding: 0,
    backgroundColor: theme.colors.brand.darkest,
  },
  verticalContainer: {
    minHeight: 400,
    flex: 1,
  },
  horizontalContainer: {
    display: "flex",
    overflowY: "scroll",

    "::-webkit-scrollbar": {
      width: 0,
      height: theme.spacing.xsmall2,
    },
    "::-webkit-scrollbar-thumb": {
      background: theme.colors.light.base,
      borderRadius: theme.spacing.small,
    },
    "::-webkit-scrollbar-thumb:hover": {
      background: theme.colors.brand.light,
    },
  },
  item: {
    height: 54,
    display: "flex",
    alignItems: "center",
    cursor: "not-allowed",
    transition: "color 0.4s",
    color: theme.colors.light.base,
  },
  activeItemChildren: {
    width: "100%",
  },
  chevron: {
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
    padding: theme.spacing.xsmall,
  },
  chevronDisabled: {
    cursor: "default",
    display: "hidden",
  },
});
